<template>
  <header>
    <nav class="container">
      <div class="branding">
        <router-link class="header" :to="{ name: 'Home' }"> SOS</router-link>
      </div>
      <div class="nav-links">
        <ul v-show="!mobileMode">
          <router-link v-if="!user" class="link" :to="{ name: 'Login' }">
            Login</router-link
          >
          <router-link v-if="!user" class="link" :to="{ name: 'Register' }">
            Register Here</router-link
          >
          <router-link v-if="user" class="link" :to="{ name: 'Dashboard' }">
            Dashboard</router-link
          >
          <router-link v-if="user" class="link" :to="{ name: 'Saviour' }">
            Saviour Mode</router-link
          >
          <router-link v-if="user" class="link" :to="{ name: 'OrderNow' }">
            Order Now</router-link
          >
          <router-link v-if="user" class="link" :to="{ name: 'Cart' }">
            Cart</router-link
          >
          <router-link
            v-if="easterEgg"
            class="link"
            :to="{ name: 'DiscoArea' }"
          >
            Disco Area</router-link
          >
        </ul>
        <div
          class="profile"
          ref="profile"
          @click.prevent="toggleProfileMenu"
          v-if="user"
        >
          <span>{{ this.$store.state.profileInitials }}</span>
          <!--
            I think v-show and v-if, both work fine down ::
            -->
          <div class="profile-menu" v-show="profileMenuShow">
            <div class="info">
              <p class="initials">{{ this.$store.state.profileInitials }}</p>
              <div class="right">
                <p>
                  {{ this.$store.state.profileFirstName }}
                  {{ this.$store.state.profileLastName }}
                </p>
                <p>{{ this.$store.state.profileUsername }}</p>
                <p>{{ this.$store.state.profileEmail }}</p>
              </div>
            </div>
            <!--
              Add custom auto off menu when clicked on any option,
              confirm with web/video
              -->
            <div class="options">
              <div class="option">
                <router-link class="option" :to="{ name: 'Profile' }">
                  <UserIcon class="icon" />
                  <p>Profile</p>
                </router-link>
              </div>
              <div @click.prevent="signOutUser" class="option">
                <SignOutIcon class="icon" />
                <p>Sign Out</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <MenuIcon @click="toggleMobileNav" class="menu-icon" v-show="mobileMode" />
    <transition name="mobile-nav">
      <ul class="mobile-nav" v-show="mobileNavShow">
        <router-link v-if="!user" class="link" :to="{ name: 'Login' }">
          Login</router-link
        >
        <router-link v-if="!user" class="link" :to="{ name: 'Register' }">
          Register Here</router-link
        >
        <router-link v-if="user" class="link" :to="{ name: 'Dashboard' }">
          Dashboard</router-link
        >
        <router-link v-if="user" class="link" :to="{ name: 'Saviour' }">
          Saviour Mode</router-link
        >
        <router-link v-if="user" class="link" :to="{ name: 'OrderNow' }">
          Order Now</router-link
        >
        <router-link v-if="user" class="link" :to="{ name: 'Cart' }">
          Cart</router-link
        >
        <router-link v-if="easterEgg" class="link" :to="{ name: 'DiscoArea' }">
          Disco Area</router-link
        >
      </ul>
    </transition>
  </header>
  <!--
  <div class="links">
    <router-link :to="{ name: 'Login' }"> Login</router-link>
    <br />
    <router-link :to="{ name: 'Register' }"> Register Here</router-link>
    <br />
    <router-link :to="{ name: 'ForgotPassword' }"
      >Forgot Your Password?</router-link
    >
  </div>
  -->
</template>

<script>
import MenuIcon from "../assets/Icons/bars-regular.svg";
import UserIcon from "../assets/Icons/user-alt-light.svg";
import SignOutIcon from "../assets/Icons/sign-out-alt-regular.svg";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Navigation",
  components: {
    MenuIcon,
    SignOutIcon,
    UserIcon,
  },
  data() {
    return {
      easterEgg: false,
      profileMenuShow: false,
      mobileMode: false,
      mobileNavShow: false,
      windowWidth: null,
      //currentRoute: this.$route.name,
    };
  },
  created() {
    window.addEventListener("resize", this.checkScreenSize);
    this.checkScreenSize();
  },
  methods: {
    signOutUser() {
      firebase.auth().signOut();
      this.$router.push({ name: "Home" });
      window.location.reload();
    },
    toggleProfileMenu(eventParam) {
      if (eventParam.target === this.$refs.profile) {
        this.profileMenuShow = !this.profileMenuShow;
      }
    },
    toggleMobileNav() {
      this.mobileNavShow = !this.mobileNavShow;
    },
    checkScreenSize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 750) {
        this.mobileMode = true;
        return;
      }
      this.mobileMode = false;
      this.mobileNavShow = false;
      return;
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    $route() {
      this.mobileNavShow = false;
      this.profileMenuShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  //background-size: cover;
  //background-image: url("../assets/background5.jpeg");
  background-color: #fff;
  padding: 0 25px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 99;

  .link {
    font-weight: 500;
    padding: 0 8px;
    transition: 0.3s color ease;

    &:hover {
      color: #1eb8b8;
    }
  }

  nav {
    display: flex;
    padding: 25px 0;

    .branding {
      align-items: center;
      display: flex;

      .header {
        font-weight: 600;
        color: #000;
        font-size: 24px;
        text-decoration: none;
      }
    }

    .nav-links {
      position: relative;
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: flex-end;

      ul {
        margin-right: 32px;

        .link {
          margin-right: 32px;
        }

        .link:last-child {
          margin-right: 0;
        }
      }

      .profile {
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        color: #fff;
        background-color: #303030;

        // Added this due to overlapping initials menu and side-navigation bar
        @media (max-width: 750px) {
          margin-right: 30px;
        }

        span {
          pointer-events: none;
        }

        .profile-menu {
          position: absolute;
          top: 60px;
          right: 0;
          width: 250px;
          background-color: #303030;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
            0 2px 4px -1px rgba(0, 0, 0, 0.06);

          .info {
            display: flex;
            align-items: center;
            padding: 15px;
            border-bottom: 1px solid #fff;

            .initials {
              position: initial;
              width: 40px;
              height: 40px;
              background-color: #fff;
              color: #303030;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
            }

            .right {
              flex: 1;
              margin-left: 24px;

              p:nth-child(1) {
                font-size: 14px;
              }

              p:nth-child(2),
              p:nth-child(3) {
                font-size: 12px;
              }
            }
          }

          .options {
            padding: 15px;

            .option {
              text-decoration: none;
              color: #fff;
              display: flex;
              align-items: center;
              margin-bottom: 12px;

              .icon {
                width: 18px;
                height: auto;
              }

              p {
                font-size: 14px;
                margin-left: 12px;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
            /*
            Same as ^^^^^^
            .option:last-child {
              margin-bottom: 0;
            }
            */
          }
        }
      }
    }
  }

  .menu-icon {
    cursor: pointer;
    position: absolute;
    top: 32px;
    right: 25px;
    height: 25px;
    width: auto;
  }

  .mobile-nav {
    padding: 20px;
    width: 70%;
    max-width: 250px;
    display: flex;
    flex-direction: column;
    position: fixed;
    height: 100%;
    background-color: #303030;
    top: 0;
    left: 0;

    .link {
      padding: 15px 0;
      color: #fff;
    }
  }

  .mobile-nav-enter-active,
  .mobile-nav-leave-active {
    transition: all 1s ease;
  }

  .mobile-nav-enter {
    transform: translateX(-250px);
  }

  .mobile-nav-enter-to {
    transform: translateX(0);
  }

  .mobile-nav-leave-to {
    transform: translateX(-250px);
  }
}
/*
.links {
  font-size: 40px;
  margin-bottom: 50px;
}
*/
</style>
